"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
// TODO Move to formatters
var createFormatString = function createFormatString(format) {
  if (_typeof(format) === "string") {
    return format;
  }
  var date = format.date_format === "Ignore Date" ? "" : format.date_format.toUpperCase();
  var time = format.time_format === "Ignore Time" ? "" : format.time_format;
  if (time.includes("military")) {
    time = "HH:mm";
  } else {
    time = time.replace("am", "A");
  }
  return "".concat(date).concat(time ? " ".concat(time) : "").trim();
};
module.exports = createFormatString;